import { helper } from '@ember/component/helper';

import config from 'market-view-ui/config/environment';

export default helper(function ssoUrl() {
  return config.nais.ssoURL;
});
